import React from "react";
import { Link } from "react-router-dom";
import { ClientType } from "../../redux/auth/authTypes";
import "./ClientDetailCard.scss";
import { Avatar } from "../commons";
import {
  favoriteIcon,
  favouriteFilledIcon,
  locationIcon,
} from "../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ClientDashboardAvatar from "./ClientDasboardAvatar";

type CurrencyDetailsType = {
  currencySign: string | undefined;
  currencyName: string | undefined;
  currencyShortForm: string | undefined;
};
type AppProps = {
  clientData?: ClientType;
  redirectToclientDashboard: (
    clientCode: number | string | undefined,
    client_name: string | undefined,
    currencyDetails: CurrencyDetailsType
  ) => void;
  type?: string;
  handleFavorite?: any;
  isClient: number | null | undefined;
};

const ClientDetailCard = ({
  clientData,
  redirectToclientDashboard,
  type,
  handleFavorite,
  isClient,
}: AppProps) => {
  let client_name = clientData?.company_name;
  let currencySign = clientData?.currency_sign;
  let currencyName = clientData?.currency_name;
  let currencyShortForm = clientData?.currency_short_form;
  let currencyDetails = {
    currencySign,
    currencyName,
    currencyShortForm,
  };
  return (
    <>
      <div
        className="client-card"
        onClick={() =>
          redirectToclientDashboard(
            clientData?.client_code,
            client_name,
            currencyDetails
          )
        }
      >
        <div className="imageBlock">
          <ClientDashboardAvatar name={client_name} />
        </div>
        <div className="infoBlock">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className="client-code">CC - {clientData?.client_code}</div>
          </div>
          {client_name && client_name.length > 20 ? (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={
                <Tooltip id="button-view-open-item">{client_name}</Tooltip>
              }
            >
              <div className="client-name">
                {client_name?.toLowerCase()?.substr(0, 20) +
                  (client_name && client_name.length > 20 ? "..." : "")}
              </div>
            </OverlayTrigger>
          ) : (
            <div className="client-name">{client_name}</div>
          )}

          <div className="address">
            <div className="location-image">
              <img src={locationIcon} alt="" />
            </div>
            <span>
              {clientData?.city && clientData?.city != ""
                ? clientData?.city?.toLowerCase() + ", "
                : null}{" "}
              {clientData?.country?.toLowerCase()}
            </span>
          </div>
          {/* <div className="show-detail pointer">
                    View Detail
                </div> */}
        </div>
      </div>

      {
        <>
          <div
            className="favourite-icon"
            onClick={() => handleFavorite(clientData?.client_code, type)}
          >
            {type === "favourite" ? (
              <img src={favouriteFilledIcon} alt="favoriteFilled" />
            ) : (
              <img src={favoriteIcon} alt="favoriteIcon" />
            )}
          </div>
        </>
      }
    </>
  );
};

export default ClientDetailCard;
